import React, { useState, useEffect } from "react";
import {Button, createTheme, Grid, IconButton, InputBase, ThemeProvider, Typography} from '@material-ui/core';
import {useHistory} from 'react-router-dom';
import useStyles from '../../assets/styles';
import { DropDown } from "../components/DropDown";
import { TableNameSearch } from "./components/SearchTable";
import { TicketColumnsEnum } from "src/app/models";
import { hasUserPermission } from "src/app/permission";

export const ServiceNowDetailsComponent = ({serviceNowBoard, serviceNowURL, password, username, tableName, onTableSelect, handleInputChange, handleSubmit, handlePartialSubmit, handleRedirect, decreaseStep, increaseStep, handleValidate, nameError, urlError, usernameError, passwordError, tableNameError, isInputDisabled, getAvailableOptions, handleColumnMappingChange, columnMapping, columnErrors, areDropdownsDisabled, validationError, isprojectExist, projectDetail}) => {
    const theme = createTheme({
        typography: {
            fontFamily: "'Poppins', sans-serif",
        },
    });
    const classes = useStyles();
    return(
        <ThemeProvider theme={theme}>
            <div>
                <Grid container className={classes.root}>
                    <Grid item xs={12} md={12}>
                        <Grid container className={classes.formContent}>
                            <Grid container className={classes.dataStreamBoxContainer}>
                                <Grid
                                    item
                                    container
                                    xs={12}
                                    md={12}
                                    alignItems="flex-start"
                                    style={{ marginBottom: "20px" }}
                                >
                                    <Grid item xs={12} md={12}>
                                    <Typography className={classes.typo}>
                                        ServiceNow Board Name <span style={{ color: "red" }}>*</span>
                                    </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <InputBase
                                        className={classes.formInput}
                                        type="text"
                                        placeholder="Enter servicenow borad name here"
                                        name="boardName"
                                        value={isprojectExist ? projectDetail.serviceNowBoard : serviceNowBoard}
                                        onChange={handleInputChange}
                                        disabled={isprojectExist}
                                        />
                                    </Grid>
                                    {nameError && (
                                    <Grid
                                        item
                                        container
                                        xs={12}
                                        md={12}
                                        justifyContent="flex-end"
                                        alignItems="center"
                                        style={{ padding: "0px 8px" }}
                                    >
                                        <Typography className={classes.errorText}>
                                        {nameError}
                                        </Typography>
                                    </Grid>
                                    )}
                                </Grid>
                                <Grid
                                    item
                                    container
                                    xs={12}
                                    md={12}
                                    alignItems="flex-start"
                                    style={{ marginBottom: "20px" }}
                                >
                                    <Grid item xs={12} md={12}>
                                        <Typography className={classes.typo}>
                                            ServiceNow URL <span style={{ color: "red" }}>*</span>
                                        </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <InputBase
                                            className={classes.formInput}
                                            type="text"
                                            placeholder="Enter servicenow url here"
                                            name="url"
                                            value={isprojectExist ? projectDetail.serviceNowURL : serviceNowURL}
                                            onChange={handleInputChange}
                                            disabled={isprojectExist}
                                            />
                                        </Grid>
                                        {urlError && (
                                        <Grid
                                            item
                                            container
                                            xs={12}
                                            md={12}
                                            justifyContent="flex-end"
                                            alignItems="center"
                                            style={{ padding: "0px 8px" }}
                                        >
                                            <Typography className={classes.errorText}>
                                            {urlError}
                                            </Typography>
                                        </Grid>
                                        )}
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={6}
                                        style={{ marginBottom: "20px" }}
                                    >
                                        <Grid item xs={12} md={12}>
                                        <Typography className={classes.typo}>
                                            Admin username
                                            <span style={{ color: 'red' }}>*</span>
                                        </Typography> 
                                        </Grid>                                      
                                        <Grid item xs={12} md={12}>
                                            <InputBase
                                            className={classes.formInput}
                                            type="text"
                                            placeholder="Enter admin username here"
                                            name="username"
                                            value={isprojectExist ? projectDetail.username : username}
                                            onChange={handleInputChange}
                                            disabled={isprojectExist}
                                            />
                                        </Grid>
                                        {usernameError && (
                                        <Grid
                                            item
                                            container
                                            xs={12}
                                            md={12}
                                            justifyContent="flex-end"
                                            alignItems="center"
                                            style={{ padding: "0px 8px" }}
                                        >
                                            <Typography className={classes.errorText}>
                                            {usernameError}
                                            </Typography>
                                        </Grid>
                                        )}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={6}
                                        style={{ marginBottom: "20px" }}
                                    >
                                        <Grid item container xs={12} md={12}>
                                            <Typography className={classes.typo}>
                                               Admin Password
                                                <span style={{ color: 'red' }}>*</span>
                                            </Typography>  
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <InputBase
                                            className={classes.formInput}
                                            type="text"
                                            placeholder="Enter admin password here"
                                            name="password"
                                            value={isprojectExist ? projectDetail.password : password}
                                            onChange={handleInputChange}
                                            disabled={isprojectExist}
                                            />
                                        </Grid>
                                        {passwordError && (
                                        <Grid
                                            item
                                            container
                                            xs={12}
                                            md={12}
                                            justifyContent="flex-end"
                                            alignItems="center"
                                            style={{ padding: "0px 8px" }}
                                        >
                                            <Typography className={classes.errorText}>
                                            {passwordError}
                                            </Typography>
                                        </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                                <Button
                                    variant="contained"
                                    className={`${classes.devicePulseSaveButton} ${classes.button}`}
                                    onClick={handleValidate}
                                    disabled={isprojectExist}
                                >
                                    Fetch Tables
                                </Button>
                                {validationError && (
                                    <Grid item xs={12} style={{ padding: "0px 8px", marginTop: "8px" }}>
                                        <Typography className={classes.errorText}>
                                            {validationError}
                                        </Typography>
                                    </Grid>
                                )}
                                <Grid
                                    item
                                    container
                                    xs={12}
                                    md={12}
                                    alignItems="flex-start"
                                    style={{ marginBottom: "20px", marginTop: "20px" }}
                                >
                                    <Grid item xs={12} md={12}>
                                    <Typography className={classes.typo}>
                                        Table Name <span style={{ color: "red" }}>*</span>
                                    </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <TableNameSearch
                                            value={isprojectExist ? `${projectDetail.tableName}` : tableName}
                                            onChange={handleInputChange}
                                            error={tableNameError}
                                            disabled={isInputDisabled}
                                            onSelect={onTableSelect}
                                        />
                                    </Grid>
                                    {tableNameError && (
                                    <Grid
                                        item
                                        container
                                        xs={12}
                                        md={12}
                                        justifyContent="flex-end"
                                        alignItems="center"
                                        style={{ padding: "0px 8px" }}
                                    >
                                        <Typography className={classes.errorText}>
                                        {tableNameError}
                                        </Typography>
                                    </Grid>
                                    )}
                                </Grid>
                                <Button
                                    variant="contained"
                                    className={`${classes.devicePulseSaveButton} ${classes.button}`}
                                    onClick={handlePartialSubmit}
                                    disabled={isprojectExist}
                                >
                                    Fetch Columns
                                </Button>
                                <Grid container spacing={2} style={{ marginTop: "15px", padding:"5px" }} justifyContent="flex-start">
                                    <Typography style={{fontWeight:600, fontSize:"16px", marginBottom:"20px"}}>Column Mapping</Typography>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={6} style={{ marginBottom: "20px" }}>
                                        <Grid item xs={12} md={12}>
                                            <Typography className={classes.typo}>
                                                Ticket ID
                                                <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <DropDown
                                                options={getAvailableOptions(TicketColumnsEnum.TICKET_ID)}
                                                emptyTag='Select ticket id'
                                                onClick={(value) => handleColumnMappingChange(TicketColumnsEnum.TICKET_ID, value)}
                                                value={isprojectExist ? (projectDetail.columnsMap || {})[TicketColumnsEnum.TICKET_ID] || '' : columnMapping[TicketColumnsEnum.TICKET_ID] || ''}                                                
                                                disabled={isprojectExist || areDropdownsDisabled}
                                                isSingle={true}
                                            />
                                            {columnErrors[TicketColumnsEnum.TICKET_ID] && (
                                                <Grid item xs={12} style={{ padding: "0px 8px" }}>
                                                    <Typography className={classes.errorText}>
                                                        {columnErrors[TicketColumnsEnum.TICKET_ID]}
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} style={{ marginBottom: "20px" }}>
                                        <Grid item container xs={12} md={12}>
                                            <Typography className={classes.typo}>
                                                Ticket Status
                                                <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <DropDown
                                                options={getAvailableOptions(TicketColumnsEnum.TICKET_STATUS)}
                                                emptyTag='Select the column name that holds the status of each ticket'
                                                onClick={(value) => handleColumnMappingChange(TicketColumnsEnum.TICKET_STATUS, value)}
                                                value={isprojectExist ? (projectDetail.columnsMap || {})[TicketColumnsEnum.TICKET_STATUS] || '' : columnMapping[TicketColumnsEnum.TICKET_STATUS] || ''}                                                
                                                disabled={isprojectExist || areDropdownsDisabled}
                                                isSingle={true}
                                            />
                                            {columnErrors[TicketColumnsEnum.TICKET_STATUS] && (
                                                <Grid item xs={12} style={{ padding: "0px 8px" }}>
                                                    <Typography className={classes.errorText}>
                                                        {columnErrors[TicketColumnsEnum.TICKET_STATUS]}
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={6} style={{ marginBottom: "20px" }}>
                                        <Grid item xs={12} md={12}>
                                            <Typography className={classes.typo}>
                                                Ticket Title / Summary
                                                <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <DropDown
                                                options={getAvailableOptions(TicketColumnsEnum.TICKET_SUMMARY)}
                                                emptyTag='Select ticket title / summary'
                                                onClick={(value) => handleColumnMappingChange(TicketColumnsEnum.TICKET_SUMMARY, value)}
                                                value={isprojectExist ? (projectDetail.columnsMap || {})[TicketColumnsEnum.TICKET_SUMMARY] || '' : columnMapping[TicketColumnsEnum.TICKET_SUMMARY] || ''}                                                
                                                disabled={isprojectExist || areDropdownsDisabled}
                                                isSingle={true}
                                            />
                                            {columnErrors[TicketColumnsEnum.TICKET_SUMMARY] && (
                                                <Grid item xs={12} style={{ padding: "0px 8px" }}>
                                                    <Typography className={classes.errorText}>
                                                        {columnErrors[TicketColumnsEnum.TICKET_SUMMARY]}
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} style={{ marginBottom: "20px" }}>
                                        <Grid item container xs={12} md={12}>
                                            <Typography className={classes.typo}>
                                                Assigned To
                                                <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <DropDown
                                                options={getAvailableOptions(TicketColumnsEnum.ASSIGNED_TO)}
                                                emptyTag='Select the column name that stores who is assigned to each ticket'
                                                onClick={(value) => handleColumnMappingChange(TicketColumnsEnum.ASSIGNED_TO, value)}
                                                value={isprojectExist ? (projectDetail.columnsMap || {})[TicketColumnsEnum.ASSIGNED_TO] || '' : columnMapping[TicketColumnsEnum.ASSIGNED_TO] || ''}                                                
                                                disabled={isprojectExist || areDropdownsDisabled}
                                                isSingle={true}
                                            />
                                            {columnErrors[TicketColumnsEnum.ASSIGNED_TO] && (
                                                <Grid item xs={12} style={{ padding: "0px 8px" }}>
                                                    <Typography className={classes.errorText}>
                                                        {columnErrors[TicketColumnsEnum.ASSIGNED_TO]}
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item container xs={12} md={12} alignItems="flex-start" style={{ marginBottom: "20px" }}>
                                    <Grid item xs={12} md={12}>
                                        <Typography className={classes.typo}>
                                            Ticket Description
                                            <span style={{ color: 'red' }}>*</span>
                                        </Typography>
                                        <DropDown
                                            options={getAvailableOptions(TicketColumnsEnum.TICKET_DESCRIPTION)}
                                            emptyTag='Select ticket description'
                                            onClick={(value) => handleColumnMappingChange(TicketColumnsEnum.TICKET_DESCRIPTION, value)}
                                            value={isprojectExist ? (projectDetail.columnsMap || {})[TicketColumnsEnum.TICKET_DESCRIPTION] || '' : columnMapping[TicketColumnsEnum.TICKET_DESCRIPTION] || ''}                                                
                                            disabled={isprojectExist || areDropdownsDisabled}
                                            isSingle={true}
                                        />
                                        {columnErrors[TicketColumnsEnum.TICKET_DESCRIPTION] && (
                                            <Grid item xs={12} style={{ padding: "0px 8px" }}>
                                                <Typography className={classes.errorText}>
                                                    {columnErrors[TicketColumnsEnum.TICKET_DESCRIPTION]}
                                                </Typography>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={6} style={{ marginBottom: "20px" }}>
                                        <Grid item xs={12} md={12}>
                                            <Typography className={classes.typo}>
                                                Reporter
                                                <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <DropDown
                                                options={getAvailableOptions(TicketColumnsEnum.REPORTER)}
                                                emptyTag='Select reporter'
                                                onClick={(value) => handleColumnMappingChange(TicketColumnsEnum.REPORTER, value)}
                                                value={isprojectExist ? (projectDetail.columnsMap || {})[TicketColumnsEnum.REPORTER] || '' : columnMapping[TicketColumnsEnum.REPORTER] || ''}                                                
                                                disabled={isprojectExist || areDropdownsDisabled}
                                                isSingle={true}
                                            />
                                            {columnErrors[TicketColumnsEnum.REPORTER] && (
                                                <Grid item xs={12} style={{ padding: "0px 8px" }}>
                                                    <Typography className={classes.errorText}>
                                                        {columnErrors[TicketColumnsEnum.REPORTER]}
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} style={{ marginBottom: "20px" }}>
                                        <Grid item container xs={12} md={12}>
                                            <Typography className={classes.typo}>
                                                Ticket Priority
                                                <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <DropDown
                                                options={getAvailableOptions(TicketColumnsEnum.TICKET_PRIORITY)}
                                                emptyTag='Select ticket priority'
                                                onClick={(value) => handleColumnMappingChange(TicketColumnsEnum.TICKET_PRIORITY, value)}
                                                value={isprojectExist ? (projectDetail.columnsMap || {})[TicketColumnsEnum.TICKET_PRIORITY] || '' : columnMapping[TicketColumnsEnum.TICKET_PRIORITY] || ''}                                                
                                                disabled={isprojectExist || areDropdownsDisabled}
                                                isSingle={true}
                                            />
                                            {columnErrors[TicketColumnsEnum.TICKET_PRIORITY] && (
                                                <Grid item xs={12} style={{ padding: "0px 8px" }}>
                                                    <Typography className={classes.errorText}>
                                                        {columnErrors[TicketColumnsEnum.TICKET_PRIORITY]}
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                    
                                <Grid container spacing={2} style={{ marginTop: "5px" }} justifyContent="flex-end">
                                    <Grid item>
                                        <Button
                                        variant="contained"
                                        className={classes.backButton}
                                        style={{margin: "0px"}}
                                        onClick={decreaseStep}
                                        >
                                        Back
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                        variant="contained"
                                        className={`${classes.devicePulseSaveButton} ${classes.button}`}
                                        onClick={isprojectExist ? handleRedirect : increaseStep}
                                        disabled={isprojectExist && !hasUserPermission("SETUP_DEVICE_PULSE.ITSM_CONFIGURATION.SERVICE_NOW", "EDIT")}>
                                            {isprojectExist ? "Edit" : "Next"}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>                                                         
            </div>
        </ThemeProvider>
    )
}